import { supabase } from "../lib/supabaseClient";
import { UploadConflictKey } from "../types/operations";

export interface UploadLogKey {
  upload_date: string;
  machine_type: string;
}

export async function fetchUploadLogConflicts(
  keys: UploadLogKey[]
): Promise<UploadConflictKey[]> {
  if (keys.length === 0) {
    return [];
  }

  const dates = [...new Set(keys.map((k) => k.upload_date))];
  const types = [...new Set(keys.map((k) => k.machine_type))];

  const { data, error } = await supabase
    .from("upload_log")
    .select("upload_date, machine_type")
    .in("upload_date", dates)
    .in("machine_type", types);

  if (error) {
    throw new Error(`Failed to check upload log: ${error.message}`);
  }

  if (!data || data.length === 0) {
    return [];
  }

  const existingSet = new Set(
    data.map((row: { upload_date: string; machine_type: string }) =>
      `${row.upload_date}|${row.machine_type}`
    )
  );

  return keys
    .filter((k) => existingSet.has(`${k.upload_date}|${k.machine_type}`))
    .map((k) => ({ date: k.upload_date, machineType: k.machine_type }));
}

export async function insertUploadLogEntries(
  keys: UploadLogKey[]
): Promise<void> {
  if (keys.length === 0) {
    return;
  }

  const { error } = await supabase
    .from("upload_log")
    .insert(keys.map((k) => ({
      upload_date: k.upload_date,
      machine_type: k.machine_type,
    })));

  if (error) {
    throw new Error(`Failed to record upload log entries: ${error.message}`);
  }
}
